import { AxiosResponse } from "axios"
import { apiWithEncryption } from "context/queryEncrypted"

export const login = async (data: App.LoginPayload): Promise<AxiosResponse> => {
  const response = await apiWithEncryption.post("/login", data)

  return response
}

export const confirmLoginCode = async (
  data: App.ConfirmLoginPayload = { code: "", token: "", email: "" }
): Promise<string> => {
  const { code, token, email } = data

  const response = await apiWithEncryption.post(
    "/confirm-login",
    { code, email },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return response?.data.token
}

export const resendCodeEmail = async (data: App.ResendLoginCodePayload = { token: "", email: "" }): Promise<string> => {
  const { token, email } = data

  const response = await apiWithEncryption.post(
    "/confirm-login-resend",
    { email },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return response?.data.token
}
